import { Component, Input, EventEmitter, Output} from '@angular/core';

/**
   * Logger Factory
   * @namespace item: title, subtitle and icon to shoow
   * <ute-generic-list-item-group [items]="items"></ute-generic-list-item-group>
*/

@Component({
  selector: 'ute-generic-list-item-group',
  templateUrl: 'ute-generic-list-item-group.component.html'
})
export class UteGenericListItemGroup  {
  @Input() items: any[];
  @Output() itemSelected = new EventEmitter;

  public idWifiSelected: number;

  constructor() {
    this.idWifiSelected = null;
  }
   
  ngOnInit() {
    
  }

  onItemSelected(item){
    this.idWifiSelected = item.id;
    this.itemSelected.emit(item);
  }

 
}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-generic-list-item-group/ute-generic-list-item-group.component.ts